import { ActionableCardStrings } from 'owa-actionable-message-v2';
import {
    actionInProgressMessage1,
    defaultPlaceholderTextInput1,
    warningMessageForInvalidInput1,
    warningMessageForMissingRequiredInput1,
} from '../strings/ActionableMessageCard.locstring.json';

import {
    warningMessageForInputNumberMoreThanMin1,
    warningMessageForInputNumberLessThanMax1,
    warningMessageForInputNumberNotNumeric1,
} from '../strings/NumberTextField.locstring.json';
import { warningMessageForRequiredField1 } from '../strings/CustomTextInput.locstring.json';
import { getCalendarStrings } from 'owa-datepicker-common';
import loc, { format } from 'owa-localize';

export default function createActionableCardStrings(): ActionableCardStrings {
    return {
        cardDefinitionsStrings: {
            format: format,
            actionInProgressMessage: loc(actionInProgressMessage1),
            defaultPlaceholderTextInput: loc(defaultPlaceholderTextInput1),
            warningMessageForInvalidInput: loc(warningMessageForInvalidInput1),
            warningMessageForMissingRequiredInput: loc(warningMessageForMissingRequiredInput1),
            warningMessageForInputNumberNotNumeric: loc(warningMessageForInputNumberNotNumeric1),
            warningMessageForInputNumberLessThanMax: loc(warningMessageForInputNumberLessThanMax1),
            warningMessageForInputNumberMoreThanMin: loc(warningMessageForInputNumberMoreThanMin1),
            warningMessageForRequiredField: loc(warningMessageForRequiredField1),
        },
        dateStrings: getCalendarStrings(),
    };
}
